// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"678":"67e6d49237de723dc91f","883":"7afc20c8726a7644b7ac"}[chunkId] + ".js";
};